import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
 
import { ApiV2Service } from './api-v2.service';
import { ToastController } from '@ionic/angular';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    alertService: any;
    constructor(private apiService:ApiV2Service, private toastController: ToastController, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

       
        setTimeout(()=>{                           // <<<---using ()=> syntax
       // this.apiService.globalloading=false;
       // console.log('here');
        }, 500);

        return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
          

            console.log(err);
            if ([401, 403, 419].includes(err.status)) {
                return throwError(() => err);
            }

            let errormsg="Something went wrong, Please wait for a moment.";

            if(err.error?.error){
                if(err.error.error.message){
                    this.apiService.present_toast('error',err.error.error.message);
                }else{
                    this.apiService.present_toast('error',err.error.error);
                }
                
            }

           
            let errors=(err as any).errors ?? err.error?.errors;
            if(errors){
                if(errors[0].message.includes('nknown')){
                    errormsg="Something went wrong, Please wait for a moment.";
                }else{
                    errormsg=errors[0].message;
                }
                this.apiService.present_toast('error',errormsg);
            }

            // 401 is handled by AuthRefreshInterceptor (token refresh + retry).
            // Clearing storage here caused immediate logout after account switch when
            // a V1 request briefly returned 401 while the alias profile was loading.
            return throwError(() => err);
        }))
    }
}
